import {Injectable, Inject} from '@angular/core';
import {OverlayContainer} from '@angular/cdk/overlay';
import {DOCUMENT} from '@angular/common';

@Injectable()
export class OverlayInsideTuiRootContainer extends OverlayContainer {
  constructor(@Inject(DOCUMENT) private document: Document) {
    super();
  }

  protected override _createContainer(): void {
    const parent =
      this.document.querySelector('tui-root') ?? this.document.body;

    this._containerElement = this.document.createElement('div');
    this._containerElement.classList.add('cdk-overlay-container');

    parent.appendChild(this._containerElement);
  }
}
